import { useLenis } from "lenis/react";
import { ArrowUp } from "lucide-react";

export const Footer = ({ t }) => {
  const lenis = useLenis();
  return (
    <footer className="border-t border-white/10" data-testid="footer">
      <div className="mx-auto flex max-w-[1440px] flex-col items-start justify-between gap-8 px-5 py-12 md:flex-row md:items-center md:px-10">
        <img src="/assets/logo-white.png" alt="SQB Robotics" className="h-6 w-auto opacity-80" />
        <p className="font-mono-spec text-[10px] uppercase tracking-[0.25em] text-slate-500" data-testid="footer-rights">
          {t.rights}
        </p>
        <button
          onClick={() => lenis?.scrollTo(0)}
          data-testid="back-to-top-btn"
          className="group flex items-center gap-2 font-mono-spec text-[10px] uppercase tracking-[0.25em] text-slate-400 transition-colors duration-300 hover:text-[#00e5ff]"
        >
          {t.top}
          <ArrowUp className="h-3.5 w-3.5 transition-transform duration-300 group-hover:-translate-y-1" />
        </button>
      </div>
    </footer>
  );
};
